/**
 * @file 数字人主播相关通用方法&数据处理
*/
import md5 from 'md5';
import _ from 'lodash';
import {message} from 'antd';
import {toJS} from 'mobx';
import {fabric} from 'huibo-fabric';
import {Node, Transforms} from 'slate';
import {BASE_HEIGHT, BASE_WIDTH, DEFAULT_MUSIC_BG, DEFAULT_WHITE_BACKGROUND, PAGE_LIMIT_VIDEO_COUNT, PASTER_SUBTYPE, RISK_TYPE_MAP, PAGE_TYPE, CHARCTER_VIDEO_SIZE} from '../config';
import {formatDate} from '../../../utils/dateFormat';
import {toFixedFloor} from '../../../utils/dataFormat';
import {store} from '../stores';
import {getImageInfo} from '../services';
import {BLOCK_TYPE} from '../components/Index/DigitalAnchor/SSMLInput/config';
import {analyseImg} from './image';
import {extractClipPath} from './regex';
import {transElementsTextbox} from './compatible';

let globalTTS = {};

export const getUniqueElementId = () => {
    return _.uniqueId(`${new Date().getTime()}_canvasId_`);
};

export const updateGolbalTTS = ttsInfo => {
    globalTTS = ttsInfo;
};

export const diffSubmitParams = (pre, curr) => {
    return md5(JSON.stringify(pre)) === md5(JSON.stringify(curr));
};

export const randomString = (e = 16) => {
    let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let a = t.length;
    let n = '';
    for (let i = 0; i < e; i++) {
        n += t.charAt(Math.floor(Math.random() * a));
    }
    return n;
};

// 过滤模板中的数据
export const filterTemplateElements = (elements) => {
    try {
        // 人像信息不添加进来
        return elements.filter(item => item.type !== 'character' && item.moduleType !== 'character');
    }
    catch (e) {
        return elements;
    }
};

export const addGoodsToParams = ({goods, submitParams, noNewPage, templateInfo}) => {
    const newSubmitParams = {...submitParams};
    const curGoodsIndex = newSubmitParams.content.length;

    let prePage = {};
    let preCharacterElement;
    let preTTS;

    // 新建页面，复制上一页配置
    if (curGoodsIndex !== 0) {
        const prePageList = newSubmitParams.content[curGoodsIndex - 1].page_list;
        const index =  prePageList.findLastIndex(it => it?.page_type !== PAGE_TYPE.VIDEO);
        prePage = prePageList[index] || {};
    }

    preCharacterElement = (prePage.elements || []).find(ele => ele.type === 'character');
    preTTS = {...prePage.tts};

    delete preTTS.desc;

    const newPage = {
        page_index: randomString(),
        elements: (preCharacterElement ? [preCharacterElement] : [])?.map(item => {
            return {
                ...item,
                canvasId: getUniqueElementId()
            };
        }),
        tts: {
            ...preTTS
        },
        bg_music: DEFAULT_MUSIC_BG
    };

    // 使用模板的情况下 继承模板
    if (templateInfo?.length) {
        // 套装模板使用分镜2
        const targetTemplate = templateInfo.length > 2 ? templateInfo[1] : templateInfo[0];
        let {elements, bg_music} = targetTemplate;
        elements = filterTemplateElements(elements);
        newPage.elements = (preCharacterElement ? [...elements, preCharacterElement] : [...elements])?.map(item => {
            return {
                ...item,
                canvasId: getUniqueElementId(),
                subtype: PASTER_SUBTYPE.TEMPLATE
            };
        });
        newPage.bg_music = bg_music;
    }

    let newGoodsId = `${goods.goods_id}-${Date.now().toString()}`;
    return {
        newSubmitParams: {
            ...submitParams,
            content: [
                ...submitParams.content,
                {
                    goods_id: newGoodsId,
                    num_id: goods.num_id,
                    goods_name: goods.newTitle || goods.originalTitle,
                    goods_index: submitParams.content.length,
                    goods_imageList: goods.imageList,
                    platform: goods.platform || '',
                    goods_price: goods.price,
                    open_platform: goods.open_platform,
                    is_open: goods.is_open,
                    goods_pcLandPage: goods.pcLandPage,
                    page_list: noNewPage ? [] : [
                        // 默认创建一个页面
                        newPage
                    ]
                }
            ]
        },
        newGoodsId,
        newPage
    };
};
export const addAIGCGoodToParams = ({goods, submitParams, descList, templateInfo, genType, genTaskId, aiCreateIds, aiGenIds}) => {
    const createTime = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
    let prePage = {};
    let preCharacterElement;
    let preTTS;

    // 新建页面，复制上一页配置

    preCharacterElement = (prePage.elements || []).find(ele => ele.type === 'character');
    preTTS = {...prePage.tts};

    delete preTTS.desc;

    let newGoodsId = `${goods.goods_id}-${Date.now().toString()}`; // 使用模板的情况下 继承模板
    const AigcDescList = descList.map((item, index) => {
        const newPage = {
            selected: index === 0,
            elements: (preCharacterElement ? [preCharacterElement] : [])?.map(item => {
                return {
                    ...item,
                    canvasId: getUniqueElementId()
                };
            }),
            page_index: randomString(),
            tts: {
                ...preTTS,
                desc: formatDesc2SSML(item.desc, 1000),
                gen_type: genType,
                gen_task_id: genTaskId,
                ai_create_ids: aiCreateIds,
                ai_gen_ids: aiGenIds
            }
        };
        if (templateInfo?.length) {
            // 套装模板使用分镜2
            const targetTemplate = templateInfo.length > 2 ? templateInfo[1] : templateInfo[0];
            let {elements, bg_music} = targetTemplate;
            elements = filterTemplateElements(elements);
            newPage.elements = (preCharacterElement ? [...elements, preCharacterElement] : [...elements])?.map(item => {
                return {
                    ...item,
                    canvasId: getUniqueElementId(),
                    subtype: PASTER_SUBTYPE.TEMPLATE
                };
            });
            newPage.bg_music = bg_music;
        }
        return newPage;
    });
    return {
        newSubmitParams: {
            ...submitParams,
            content: [
                ...submitParams.content,
                {
                    goods_id: newGoodsId,
                    num_id: goods.num_id,
                    goods_name: goods.newTitle || goods.originalTitle,
                    goods_index: submitParams.content.length,
                    goods_imageList: goods.imageList,
                    goods_price: goods.price,
                    goods_pcLandPage: goods.pcLandPage,
                    platform: goods.platform || '',
                    page_list: AigcDescList
                }
            ]
        },
        newGoodsId,
        newPage: AigcDescList[0]
    };
};
export const copyGoodsToParams = ({goodsId, submitParams}) => {
    let newSubmitParams = toJS(submitParams);
    let newGoods;
    let newGoodsId;
    newSubmitParams.content = submitParams.content.reduce((newArr, item, index) => {
        newArr.push(item);
        if (item.goods_id === goodsId) {
            let newPageList = [];
            item.page_list.length && item.page_list.forEach(page => {
                newPageList.push({
                    ...page,
                    page_index: randomString()
                });
            });
            const goodsId = item.goods_id.split('-')[0];
            newGoodsId = `${goodsId}-${Date.now().toString()}`;
            newGoods = {
                ...item,
                goods_id: newGoodsId,
                page_list: newPageList
            };
            newArr.push(newGoods);
        }
        return newArr;
    }, []);
    return {newSubmitParams, newGoodsId};
};

export const removeGoodsFromParams = (curGoodsId, submitParams) => {
    const newSubmitParams = toJS(submitParams);
    let newActiveGoodsId;
    let newActivePage;
    submitParams.content.forEach((item, index) => {
        if (item.goods_id === curGoodsId) {
            if (index - 1 >= 0) {
                newActiveGoodsId = submitParams.content[index - 1].goods_id;
                newActivePage = submitParams.content[index - 1].page_list.length ? submitParams.content[index - 1].page_list[0] : '';
            }
            else if (index + 1 < submitParams.content.length) {
                newActiveGoodsId = submitParams.content[index + 1].goods_id;
                newActivePage = submitParams.content[index + 1].page_list.length ? submitParams.content[index + 1].page_list[0] : '';
            }
        }
    });

    newSubmitParams.content = submitParams.content.filter(ele => {
        return ele.goods_id !== curGoodsId;
    });


    return {newSubmitParams, newActiveGoodsId, newActivePage};
};

export const replaceGoodsInParams = ({goods, submitParams, curGoodsId}) => {
    let firPage;

    const newSubmitParams = toJS(submitParams);
    let newGoodsId;
    newSubmitParams.content.forEach(goodsItem => {
        const {goods_id: goodsId, coverMap, page_list: pageList, platform} = goodsItem;

        if (goodsId === curGoodsId) {
            newGoodsId = `${goods.goods_id}-${Date.now().toString()}`;
            goodsItem.goods_id = newGoodsId;
            goodsItem.num_id = goods.num_id;
            goodsItem.goods_name = goods.newTitle || goods.originalTitle;
            goodsItem.goods_imageList = goods.imageList;
            goodsItem.goods_price = goods.price;
            goodsItem.open_platform = goods.open_platform,
            goodsItem.is_open = goods.is_open,
            goodsItem.goods_pcLandPage = goods.pcLandPage;
            goodsItem.platform = goods.platform;
            firPage = pageList.length ? pageList[0] : '';
        }
    });
    return {newSubmitParams, newPage: firPage, newGoodsId};
};

export const replaceGoodsInCustomAudio = (newGoods, curGoodsId, customAudioMap) => {
    if (customAudioMap) {
        let tmpKey = '';
        let tmpAudio = '';

        for (let audioKey in customAudioMap) {
            if (String(audioKey.split('_')[0]) === String(curGoodsId)) {
                tmpKey = audioKey;
                tmpAudio = customAudioMap[audioKey];
            }
        }

        const newKey = `${newGoods.goods_id}_${tmpKey.split('_')[1]}`;
        customAudioMap[newKey] = tmpAudio;
        delete customAudioMap[tmpKey];

        return customAudioMap;
    }
};

export const addPageToParams = (curGoodsId, pageIndex, submitParams, addType, type, templateInfo) => {
    const newSubmitParams = toJS(submitParams);
    const curGoodsIndex = newSubmitParams.content.findIndex(ele => ele.goods_id === curGoodsId);
    const curGoodsItem = newSubmitParams.content[curGoodsIndex];

    let prePage = {};
    let preCharacterElement;
    let preTTS;
    let preBgMusice;

    // 新建页面，复制上一页配置
    if (curGoodsItem.page_list.length) {
        const index =  curGoodsItem.page_list.findLastIndex(it => it?.page_type !== PAGE_TYPE.VIDEO);
        prePage = curGoodsItem.page_list[index] || {};
    }
    else if (curGoodsIndex !== 0) {
        const prePageList = newSubmitParams.content[curGoodsIndex - 1].page_list;
        const index =  prePageList.findLastIndex(it => it?.page_type !== PAGE_TYPE.VIDEO);
        prePage = prePageList[index] || {};
    }

    preCharacterElement = (prePage.elements || []).find(ele => ele.type === 'character');
    preTTS = {...prePage.tts};
    preBgMusice = {...prePage.bg_music};

    delete preTTS.desc;
    delete preTTS.is_ai_gen;
    delete preTTS.ai_gen_time;
    delete preTTS.is_ai_create;
    delete preTTS.ai_create_time;
    delete preTTS.duration;

    const newPage = {
        page_type: PAGE_TYPE.DEFAULT,
        page_index: randomString(),
        elements: (preCharacterElement ? [preCharacterElement] : [])?.map(item => {
            return {
                ...item,
                canvasId: getUniqueElementId()
            };
        }),
        tts: {
            ...preTTS
        },
        bg_music: preBgMusice
    };

    // 使用模板的情况下 新建分镜 继承模板
    if (type === 'push' && templateInfo?.length) {
        // 套装模板使用分镜2
        const targetTemplate = templateInfo.length > 2 ? templateInfo[1] : templateInfo[0];
        let {elements, bg_music} = targetTemplate;
        elements = filterTemplateElements(elements);
        newPage.elements = (preCharacterElement ? [...elements, preCharacterElement] : [...elements])?.map(item => {
            return {
                ...item,
                canvasId: getUniqueElementId(),
                subtype: PASTER_SUBTYPE.TEMPLATE
            };
        });
        newPage.bg_music = bg_music;
    }

    if (pageIndex && type !== 'push') {
        const curActivePage = curGoodsItem.page_list.find(item => item.page_index === pageIndex);

        if (curActivePage) {
            newPage.tts = {
                ...curActivePage.tts,
                desc: '',
                is_ai_gen: 0,
                ai_gen_time: '',
                is_ai_create: 0,
                ai_create_time: ''
            };
            newPage.bg_music = {...curActivePage.bg_music};
            const curActiveCharacter = curActivePage.elements.find(ele => ele.type === 'character');
            if (curActiveCharacter && addType === 'add') {
                newPage.elements = [curActiveCharacter]?.map(item => {
                    return {
                        ...item,
                        canvasId: getUniqueElementId()
                    };
                });
            }
            else if (addType === 'copy') {
                newPage.page_type = curActivePage.page_type || PAGE_TYPE.DEFAULT;
                newPage.elements = [...curActivePage.elements]?.map(item => {
                    return {
                        ...item,
                        canvasId: getUniqueElementId()
                    };
                });
            }
        }
        const insertIndex = curGoodsItem.page_list.findIndex(item => item.page_index === pageIndex);
        curGoodsItem.page_list.splice(insertIndex + 1, 0, newPage);
    }
    else {
        curGoodsItem.page_list.push(newPage);
    }

    return {newSubmitParams, newPage};
};

// 创建切镜页面,如果装修模板中有视频贴片，则删除视频贴片
export const addVideoPageToParams = (curGoodsId, pageIndex, submitParams, addType, type, templateInfo) => {
    const newSubmitParams = toJS(submitParams);
    const curGoodsIndex = newSubmitParams.content.findIndex(ele => ele.goods_id === curGoodsId);
    const curGoodsItem = newSubmitParams.content[curGoodsIndex];

    let prePage = {};
    let preCharacterElement;
    let preTTS;
    let preBgMusice;
    let preElements;

    // 新建页面，复制上一页配置
    if (curGoodsItem.page_list.length) {
        prePage = curGoodsItem.page_list[curGoodsItem.page_list.length - 1] || {};
    }
    else if (curGoodsIndex !== 0) {
        const prePageList = newSubmitParams.content[curGoodsIndex - 1].page_list;
        prePage = prePageList[prePageList.length - 1] || {};
    }

    preCharacterElement = (prePage.elements || []).find(ele => ele.type === 'character');
    preElements = (prePage.elements || []).filter(ele => ele.type !== 'video');
    preTTS = {...prePage.tts};
    preBgMusice = {...prePage.bg_music};

    delete preTTS.desc;
    delete preTTS.is_ai_gen;
    delete preTTS.ai_gen_time;
    delete preTTS.is_ai_create;
    delete preTTS.ai_create_time;
    delete preTTS.duration;

    const newPage = {
        page_type: PAGE_TYPE.VIDEO,
        page_index: randomString(),
        elements: (preCharacterElement ? [{
            ...preCharacterElement,
            w: CHARCTER_VIDEO_SIZE.w, // 切镜尽可能的隐藏数字人，故调整w,h,x,y
            h: CHARCTER_VIDEO_SIZE.h,
            x: CHARCTER_VIDEO_SIZE.x,
            y: CHARCTER_VIDEO_SIZE.y
        }] : [])?.map(item => {
            return {
                ...item,
                canvasId: getUniqueElementId()
            };
        }),
        tts: {
            ...preTTS
        },
        bg_music: preBgMusice
    };

    // 使用模板的情况下 新建分镜 继承模板
    if (type === 'push') {
        if (preElements.length > 0) {
            newPage.elements = preElements.map(ele => {
                if (ele.type === 'character') {
                    return {
                        ...ele,
                        w: CHARCTER_VIDEO_SIZE.w, // 切镜尽可能的隐藏数字人，故调整w,h,x,y
                        h: CHARCTER_VIDEO_SIZE.h,
                        x: CHARCTER_VIDEO_SIZE.x,
                        y: CHARCTER_VIDEO_SIZE.y,
                        canvasId: getUniqueElementId()
                    };
                }
                return {
                    ...ele,
                    canvasId: getUniqueElementId()
                };
            });
        }
        else if (templateInfo?.length) {
            // 套装模板使用分镜2
            const targetTemplate = templateInfo.length > 2 ? templateInfo[1] : templateInfo[0];
            let {elements, bg_music} = targetTemplate;
            elements = filterTemplateElementsByVideo(elements);
            newPage.elements = (preCharacterElement ? [...elements, {
                ...preCharacterElement,
                w: CHARCTER_VIDEO_SIZE.w, // 切镜尽可能的隐藏数字人，故调整w,h,x,y
                h: CHARCTER_VIDEO_SIZE.h,
                x: CHARCTER_VIDEO_SIZE.x,
                y: CHARCTER_VIDEO_SIZE.y
            }] : [...elements])?.map(item => {
                return {
                    ...item,
                    canvasId: getUniqueElementId(),
                    subtype: PASTER_SUBTYPE.TEMPLATE
                };
            });
            newPage.bg_music = bg_music;
        }
    }

    if (pageIndex && type !== 'push') {
        const curActivePage = curGoodsItem.page_list.find(item => item.page_index === pageIndex);

        if (curActivePage) {
            newPage.tts = {
                ...curActivePage.tts,
                desc: '',
                is_ai_gen: 0,
                ai_gen_time: '',
                is_ai_create: 0,
                ai_create_time: ''
            };
            newPage.bg_music = {...curActivePage.bg_music};
            const curActiveCharacter = curActivePage.elements.find(ele => ele.type === 'character');
            if (curActiveCharacter && addType === 'add') {
                newPage.elements = [curActiveCharacter]?.map(item => {
                    return {
                        ...item,
                        w: CHARCTER_VIDEO_SIZE.w, // 切镜尽可能的隐藏数字人，故调整w,h,x,y
                        h: CHARCTER_VIDEO_SIZE.h,
                        x: CHARCTER_VIDEO_SIZE.x,
                        y: CHARCTER_VIDEO_SIZE.y,
                        canvasId: getUniqueElementId()
                    };
                });
            }
            else if (addType === 'copy') {
                newPage.elements = [...curActivePage.elements]?.map(item => {
                    return {
                        ...item,
                        canvasId: getUniqueElementId()
                    };
                });
            }
        }
        const insertIndex = curGoodsItem.page_list.findIndex(item => item.page_index === pageIndex);
        curGoodsItem.page_list.splice(insertIndex + 1, 0, newPage);
    }
    else {
        curGoodsItem.page_list.push(newPage);
    }
    return {newSubmitParams, newPage};
};

// 过滤模板中的数据
export const filterTemplateElementsByVideo = (elements) => {
    try {
        // 人像信息不添加进来，并且要过滤掉所有的视频贴片
        return elements.filter(item => (item.type !== 'character' && item.moduleType !== 'character' || item.type !== 'video'));
    }
    catch (e) {
        return elements;
    }
};

export const addAIGCContentToParams = (newContent, submitParams) => {
    const newSubmitParams = toJS(submitParams);
    const newPage = newContent.page_list[0];

    newSubmitParams.content.push(newContent);

    return {newSubmitParams, newPage};
};

export const addAIGCPagesToParams = (curGoodsId, descList, submitParams, templateInfo, genType, genTaskId) => {
    const newSubmitParams = toJS(submitParams);
    const curGoodsIndex = newSubmitParams.content.findIndex(ele => String(ele.goods_id) === String(curGoodsId));
    const curGoodsItem = newSubmitParams.content[curGoodsIndex];
    const createTime = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');

    let prePage = {};
    let preCharacterElement;
    let preTTS;
    let curPageList;
    let prePageList;// 当前商品分镜页面列表，上一个商品的分镜页面列表
    // 新建页面，复制上一页配置
    // 判断当前商品有没有页面，有的话复制当前商品最后一个页面配置，没有的话复制上一商品最后一个页面配置
    if (curGoodsItem.page_list.length) {
        curPageList = curGoodsItem.page_list;
        prePage = curPageList[curPageList.length - 1];
    }
    else if (curGoodsIndex !== 0) {
        prePageList = newSubmitParams.content[curGoodsIndex - 1].page_list;
        prePage = prePageList[prePageList.length - 1] || {};
    }

    preCharacterElement = (prePage.elements || []).find(ele => ele.type === 'character');
    preTTS = {...prePage.tts};

    delete preTTS.desc;

    const AigcDescList = descList.map((item, index) => {
        const newPage = {
            selected: index === 0,
            elements: (preCharacterElement ? [preCharacterElement] : [])?.map(item => {
                return {
                    ...item,
                    canvasId: getUniqueElementId()
                };
            }),
            page_index: randomString(),
            tts: {
                ...preTTS,
                desc: formatDesc2SSML(item.desc, 1000),
                is_ai_create: 1,
                ai_create_time: createTime,
                gen_type: genType,
                gen_task_id: genTaskId
            }
        };
        if (templateInfo?.length) {
            // 套装模板使用分镜2
            const targetTemplate = templateInfo.length > 2 ? templateInfo[1] : templateInfo[0];
            let {elements, bg_music} = targetTemplate;
            elements = filterTemplateElements(elements);
            newPage.elements = (preCharacterElement ? [...elements, preCharacterElement] : [...elements])?.map(item => {
                return {
                    ...item,
                    canvasId: getUniqueElementId(),
                    subtype: PASTER_SUBTYPE.TEMPLATE
                };
            });
            newPage.bg_music = bg_music;
        }
        return newPage;
    });

    if (curPageList && curPageList.length) {
        curGoodsItem.page_list = curPageList.concat(AigcDescList);
    }
    else {
        curGoodsItem.page_list = AigcDescList;
    }

    const newPage = AigcDescList[0];

    return {newSubmitParams, newPage};
};

export const removePageFromParams = (curGoodsId, pageIndex, submitParams) => {
    const newSubmitParams = toJS(submitParams);
    const curGoodsItem = newSubmitParams.content.find(ele => ele.goods_id === curGoodsId);

    const curPageIndex = curGoodsItem.page_list.findIndex(item => item.page_index === pageIndex);
    const lastPageIndex = curPageIndex === 0 ? 0 : curPageIndex - 1;
    curGoodsItem.page_list = curGoodsItem.page_list.filter(item => item.page_index !== pageIndex);
    const lastPage = curGoodsItem.page_list[lastPageIndex] || {page_index: ''};
    return {newSubmitParams, lastPage};
};

export const sortPageInParams = (curGoodsId, newPageList, submitParams) => {
    const newSubmitParams = toJS(submitParams);
    const curGoodsItem = newSubmitParams.content.find(ele => ele.goods_id === curGoodsId);

    curGoodsItem.page_list = newPageList;

    return newSubmitParams;
};

export const sortGoodsInParams = (newGoodsList, submitParams) => {
    const newSubmitParams = toJS(submitParams);

    newSubmitParams.content = newGoodsList;

    return newSubmitParams;
};

// 删除全部的数字人
export const deleteAllCharacter = submitParams => {
    try {
        const newSubmitParams = toJS(submitParams);
        newSubmitParams.content.forEach(goodsItem => {
            goodsItem.page_list.forEach(pageItem => {
                pageItem.elements = pageItem.elements.filter(ele => ele.type !== 'character');
            });
        });
        return newSubmitParams;
    }
    catch (e) {
        return submitParams;
    }
};

// 给每个页面添加一个数字人
export const addAllCharacter = (character, submitParams) => {
    try {
        const newSubmitParams = toJS(submitParams);
        newSubmitParams.content.forEach(goodsItem => {
            goodsItem.page_list.forEach(pageItem => {
                if (pageItem.elements.every(item => item.type !== 'character')) {
                    pageItem.elements.push({
                        ...character,
                        canvasId: getUniqueElementId()
                    });
                    // 调整切镜页，数字人的层级
                    if (pageItem.page_type === PAGE_TYPE.VIDEO) {
                        const elementList = updateCharacterZIndex(pageItem.elements);
                        pageItem.elements = elementList;
                    }
                }
            });
        });
        return newSubmitParams;
    }
    catch (e) {
        return submitParams;
    }
};

// 更新全部的数字人
export const updateAllCharacter = (character, submitParams) => {
    try {
        const newSubmitParams = toJS(submitParams);
        newSubmitParams.content.forEach(goodsItem => {
            goodsItem.page_list.forEach(pageItem => {
                pageItem.elements = pageItem.elements.map(item => {
                    if (item.type === 'character') {
                        return {
                            ...character,
                            // w: item.posture === character.posture ? item.w : character.w, // 相同站姿类型继承原数字人宽高位置
                            // h: item.posture === character.posture ? item.h : character.h,
                            x: item.posture === character.posture ? item.x : character.x,
                            y: item.posture === character.posture ? item.y : character.y,
                            canvasId: getUniqueElementId()
                        };
                    }
                    return item;
                });
                // 调整切镜页，数字人的层级
                if (pageItem.page_type === PAGE_TYPE.VIDEO) {
                    const elementList = updateCharacterZIndex(pageItem.elements);
                    pageItem.elements = elementList;
                }
                // 读取人像默认tts配置，需求干掉，代码保留
                // Object.assign(pageItem.tts, {
                //     ...ttsInfo
                // });
            });
        });
        return newSubmitParams;
    }
    catch (e) {
        return submitParams;
    }
};

// 当数字人发生变化时，重新更新数字人的层级
export const updateCharacterZIndex = (elements) => {
    try {
        let videoPageIndex = elements.findIndex(ele => ele.type === 'video' && ele.videoType === 'video_page');
        let characterIndex = elements.findIndex(ele => ele.type === 'character');

        if (characterIndex === -1 || videoPageIndex === -1) {
            return elements;
        }

        const video = elements[videoPageIndex];
        const character = {
            ...elements[characterIndex],
            w: CHARCTER_VIDEO_SIZE.w, // 切镜尽可能的隐藏数字人，故调整w,h,x,y
            h: CHARCTER_VIDEO_SIZE.h,
            x: video.x + video.w / 2,
            y: video.y + video.h / 2,
            canvasId: getUniqueElementId()
        };

        delete character?.canvasLeft;
        delete character?.canvasTop;

        const newElements = [...elements];

        if (characterIndex < videoPageIndex) {
            newElements[characterIndex] = character;
            newElements.splice(videoPageIndex, 1);
            newElements.splice(characterIndex + 1, 0, video);
        }
        else if (characterIndex > videoPageIndex) {
            newElements.splice(characterIndex, 1);
            newElements.splice(videoPageIndex, 0, character);
        }
        else {
            newElements[characterIndex] = character;
        }

        return newElements;
    }
    catch (error) {
        return elements;
    }
};

// 从列表里面 找一个数字人
export const getCharacterElement = submitParams => {
    const {content = []} = submitParams;
    let res;

    content.some(goods => {
        const {page_list = []} = goods;

        return page_list.some(page => {
            const {elements = []} = page;

            return elements.some(element => {
                if (element && element.type === 'character') {
                    res = element;
                }
                return res;
            });
        });
    });

    return res;
};

// 从content中找到一个数字人
export const getCharacterFromContent = (content = []) => {
    try {
        const data = typeof content === 'string' ? JSON.parse(content) : content;
        const digitalId = _.get(data, '0.smart_anchor_img.id', '');
        const digitalName = _.get(data, '0.smart_anchor_img.name', '');
        return {digitalId, digitalName};
    }
    catch (e) {
        return {};
    }
};

export const updateElementsInParams = (pageId, elements, submitParams) => {
    try {
        const [curGoodsId, pageIndex] = pageId.split('_');
        const newSubmitParams = toJS(submitParams);

        const curGoodsItem = newSubmitParams.content.find(ele => ele.goods_id === curGoodsId);
        const curPageItem = curGoodsItem.page_list.find(ele => ele.page_index === pageIndex);

        if (curPageItem) {
            curPageItem.elements = [...elements];
        }

        return newSubmitParams;
    }
    catch (e) {
        return submitParams;
    }
};

export const getBgEditTaskListInParams = submitParams => {
    try {
        let newTaskList = [];

        (submitParams.content || []).forEach(goodItem => {
            (goodItem.page_list || []).forEach((pageItem, pageIndex) => {
                const {taskList} = pageItem.elements.find(it => it.type === 'bg' && it.bgTab === 'bg_video') || {};
                if (taskList && taskList.length > 0) {
                    newTaskList = newTaskList.concat(taskList);
                }
            });
        });
        return newTaskList;
    }
    catch (error) {
        return [];
    }
};

export const updateTemplateInParams = (pageId, template, submitParams, range) => {
    try {
        const handledTemplate = template.map(it => {
            let {elements, bg_music: musicConfig} = it;

            elements = transElementsTextbox(elements);

            if (store.filteGoodsCardAuth) {
                elements = elements.filter(item => !item.isGoodsCard);
            }

            return {
                elements,
                bg_music: musicConfig
            };
        });

        const newSubmitParams = _.cloneDeep(submitParams);

        const [curGoodsId, pageIndex] = pageId.split('_');
        const curGoodsItem = newSubmitParams.content.find(ele => ele.goods_id === curGoodsId);
        const curPageItem = curGoodsItem.page_list.find(ele => ele.page_index === pageIndex);

        if (range === 'cur') {
            const {bg_music = {}} = curPageItem;
            const curCharacter = curPageItem.elements.find(item => item && item.type === 'character');
            const curTemplate = handledTemplate[0].elements;
            const curMusicConfig = handledTemplate[0].bg_music;
            curPageItem.bg_music = {...bg_music, ...curMusicConfig};
            curPageItem.elements = [...curTemplate, curCharacter].filter(item => item).map(item => ({
                ...item,
                canvasId: getUniqueElementId()
            }));
        }

        if (range === 'all') {
            let order = 0;
            newSubmitParams.content.forEach(goods => {
                goods.page_list.forEach(item => {
                    const {bg_music = {}} = item;
                    const curCharacter = item.elements.find(item => item && item.type === 'character');
                    const curMusicConfig = handledTemplate[order % handledTemplate.length].bg_music;
                    const curTemplate = handledTemplate[order % handledTemplate.length].elements;
                    curPageItem.bg_music = {...bg_music, ...curMusicConfig};
                    item.elements = [...curTemplate, curCharacter].filter(item => item).map(item => ({
                        ...item,
                        canvasId: getUniqueElementId()
                    }));
                    order++;
                });
            });
        }

        return newSubmitParams;
    }
    catch (e) {
        return submitParams;
    }
};

// 获取当前页面音频属性
export const getMusicInParams = (pageId, submitParams) => {
    try {
        const [curGoodsId, pageIndex] = pageId.split('_');

        const curGoodsItem = submitParams.content.find(ele => ele.goods_id === curGoodsId);
        const curPageItem = curGoodsItem.page_list.find(ele => ele.page_index === pageIndex);

        return curPageItem.bg_music || {};
    }
    catch (e) {
        return {};
    }
};

// 修改音频属性
export const updateMusicInParams = (pageId, musicConfig, submitParams, type) => {
    try {
        if (!pageId) {
            return;
        }

        const [curGoodsId, pageIndex] = pageId.split('_');
        const newSubmitParams = toJS(submitParams);

        const curGoodsItem = newSubmitParams.content.find(ele => ele.goods_id === curGoodsId);
        const curPageItem = curGoodsItem.page_list.find(ele => ele.page_index === pageIndex);

        // 音量设置全局生效
        if (type === 'volume') {
            newSubmitParams.content.forEach(goods => {
                goods.page_list.forEach(item => {
                    const {bg_music = {}} = item;
                    item.bg_music = {...bg_music, volume: musicConfig.volume};
                });
            });
        }
        else {
            const {range = 'cur_page'} = musicConfig; // cur_page, cur_goods, all

            if (range === 'cur_page') {
                if (curPageItem) {
                    const {bg_music = {}} = curPageItem;
                    curPageItem.bg_music = {...bg_music, ...musicConfig};
                }
            }
            else if (range === 'cur_goods') {
                curGoodsItem.page_list.forEach(item => {
                    const {bg_music = {}} = item;
                    item.bg_music = {...bg_music, ...musicConfig};
                });
            }
            else if (range === 'all') {
                newSubmitParams.content.forEach(goods => {
                    goods.page_list.forEach(item => {
                        const {bg_music = {}} = item;
                        item.bg_music = {...bg_music, ...musicConfig};
                    });
                });
            }
        }

        return newSubmitParams;
    }
    catch (e) {
        return submitParams;
    }
};

// 如果是裁剪的话则裁剪失败需要将参数还原
export const updateBgElementsInParams = (taskInfo, submitParams) => {
    const newSubmitParams = _.cloneDeep(submitParams); // toJS(submitParams);
    const {output_url = '', input_url = '', task_id = ''} = taskInfo || {};

    (newSubmitParams.content || []).forEach(it => {
        const {page_list: pageList = [], goods_id} = it;
        pageList.forEach(pageItem => {
            const newElements = (pageItem.elements || []).map(element => {
                let {editClip, editPixels, cutType, isCropping, isClipping, taskList} = element;
                const {taskId, taskName} = (taskList || []).find(it => it.taskId === task_id) || {};

                if (element.type === 'bg' && element.bgTab === 'bg_video' && taskId) {
                    return {
                        ...element,
                        taskList: taskList.filter(it => it.taskId !== taskId),
                        isCropping: taskName === 'crop' ? false : isCropping,
                        isClipping: taskName === 'trim' ? false : isClipping,
                        url: output_url || element.url,
                        editClip: (taskName === 'trim' && !output_url) ? null : editClip,
                        editPixels: (taskName === 'crop' && !output_url) ? null : editPixels,
                        poster: output_url ? `${output_url}?x-bce-process=video/snapshot,t_1000` : element.poster
                    };
                }
                return element;
            });
            pageItem.elements = newElements;
        });
    });
    return newSubmitParams;
};

// 商品页面一键应用元素
export const updateAllPageElementInParams = (target, pageId, submitParams, range) => {
    try {
        if (!pageId) {
            return submitParams;
        }
        const [curGoodsId, pageIndex] = pageId.split('_');
        const newSubmitParams = toJS(submitParams);
        const curGoodsItem = newSubmitParams.content.find(ele => ele.goods_id === curGoodsId);
        if (range === 'cur_goods') {
            curGoodsItem.page_list.forEach(item => {
                if (item.page_index === pageIndex) {
                    return;
                }
                let hasTargetIndex = item.elements.findIndex(item => item.id === target.id);
                const canvasId = getUniqueElementId();
                if (target.type === 'image') { // 由于贴图可以添加多个，所以直接添加一张图，不做替换
                    item.elements.push({
                        ...target,
                        canvasId
                    });
                }
                else if (target.type === 'video') { // 视频贴片有性能限制 校验数量
                    const videoCount = item.elements.filter(item => item.type === 'video').length;
                    if (videoCount < PAGE_LIMIT_VIDEO_COUNT) {
                        item.elements.push({
                            ...target,
                            canvasId
                        });
                    }
                }
                else if (hasTargetIndex === -1) {
                    item.elements.push({
                        ...target,
                        canvasId
                    });
                }
                else {
                    item.elements.splice(hasTargetIndex, 1, {
                        ...target,
                        canvasId
                    });
                }
            });
        }
        else if (range === 'all') {
            newSubmitParams.content.forEach(goods => {
                goods.page_list.forEach(item => {
                    if (item.page_index === pageIndex) {
                        return;
                    }
                    let hasTargetIndex = item.elements.findIndex(item => item.id === target.id);
                    const canvasId = getUniqueElementId();
                    if (target.type === 'image') { // 由于贴图可以添加多个，所以直接添加一张图，不做替换
                        item.elements.push({
                            ...target,
                            canvasId
                        });
                    }
                    else if (target.type === 'video') { // 视频贴片有性能限制 校验数量
                        const videoCount = item.elements.filter(item => item.type === 'video').length;
                        if (videoCount < PAGE_LIMIT_VIDEO_COUNT) {
                            item.elements.push({
                                ...target,
                                canvasId
                            });
                        }
                    }
                    else if (hasTargetIndex === -1) {
                        item.elements.push({
                            ...target,
                            canvasId
                        });
                    }
                    else {
                        item.elements.splice(hasTargetIndex, 1, {
                            ...target,
                            canvasId
                        });
                    }
                });
            });
        }
        message.success('一键应用成功');
        return newSubmitParams;
    }
    catch (e) {
        return submitParams;
    }
};

export const updateTTSInParams = (pageId, ttsinfo, submitParams, isGlobalAttr) => {
    try {
        const [curGoodsId, pageIndex] = pageId.split('_');
        const newSubmitParams = toJS(submitParams);

        if (isGlobalAttr) {
            updateGolbalTTS({
                ...ttsinfo,
                desc: ''
            });
            newSubmitParams.content.forEach(goodsItem => {
                goodsItem.page_list.forEach(pageItem => {
                    Object.assign(pageItem.tts, {
                        ...ttsinfo
                    });
                });
            });
        }
        else {
            const curGoodsItem = newSubmitParams.content.find(ele => ele.goods_id === curGoodsId);
            const curPageItem = curGoodsItem.page_list.find(ele => ele.page_index === pageIndex);
            let aiCreateIds = curPageItem.tts.ai_create_ids;
            let aiGenIds = curPageItem.tts.ai_gen_ids;
            if (ttsinfo.ai_create_ids) {
                aiCreateIds = curPageItem.tts.ai_create_ids ? (`${curPageItem.tts.ai_create_ids},${ttsinfo.ai_create_ids}`) : ttsinfo.ai_create_ids;
            }
            if (ttsinfo.ai_gen_ids) {
                aiGenIds = curPageItem.tts.ai_gen_ids ? (`${curPageItem.tts.ai_gen_ids},${ttsinfo.ai_gen_ids}`) : ttsinfo.ai_gen_ids;
            }
            if (curPageItem) {
                curPageItem.tts = Object.assign({}, curPageItem.tts, {
                    ...ttsinfo,
                    ai_create_ids: aiCreateIds, // 当前page所有生成的任务id
                    ai_gen_ids: aiGenIds // 使用ai脚本中辅写的所有id 和该分页所有辅写id
                });
            }
        }
        return newSubmitParams;
    }
    catch (e) {
        return submitParams;
    }
};

export const handleUpdatePptPosition = (positions, elementList) => {
    const list = (elementList || store.EditorStore.elementList).map(item => {
        if (item.type === 'ppt') {
            return {
                ...item,
                posImgs: item.posImgs.map(posI => {
                    if (posI.position === 0) {
                        return posI;
                    }
                    const hasPosI = positions.find(p => posI.canvasId === p.canvasId);
                    const hasPosIIndex = positions.findIndex(p => posI.canvasId === p.canvasId);
                    if (hasPosI) {
                        return {
                            ...posI,
                            position: hasPosI.position,
                            isError: hasPosI.position - positions[hasPosIIndex - 1].position < 25
                        };
                    }
                    if (posI.position) {
                        return {
                            ...posI,
                            position: '',
                            isError: true
                        };
                    }
                    return {
                        ...posI,
                        position: ''
                    };
                }),
                pptImage: item.posImgs.find(p => p.canvasId === item.pptImage.canvasId)
            };
        }
        return item;
    });
    if (elementList) {
        return list;
    }
    store.EditorStore.setElementList(list);
};

export const insertpptPosition = (editor, arr) => {
    let prevKeywordIndex = 0;
    arr.forEach((keyword, arrIndex) => {
        const positions = [];
        let fullText = '';
        const traverseNodes = (nodes, path = []) => {
            nodes.forEach((node, index) => {
                const newPath = path.concat(index);
                if (node.text !== undefined) {
                    fullText += node.text;
                    for (let charIndex = 0; charIndex < node.text.length; charIndex++) {
                        positions.push({path: newPath, offset: charIndex});
                    }
                }
                else if (node.children) {
                    traverseNodes(node.children, newPath);
                }
            });
        };
        traverseNodes(editor.children);
        const {txt} = keyword;
        const keywordIndex = prevKeywordIndex + fullText.substring(prevKeywordIndex, fullText.length).indexOf(txt);
        prevKeywordIndex = keywordIndex;
        if (keywordIndex !== -1) {
            const endPositionIndex = keywordIndex + txt.length;
            const endPosition = positions[endPositionIndex];
            if (endPosition) {
                const newNode = {
                    type: BLOCK_TYPE.PPT,
                    character: {...keyword},
                    children: [{text: ''}]
                };
                Transforms.insertNodes(editor, newNode, {at: {
                    path: endPosition.path,
                    offset: endPosition.offset
                }});
            }
        }
    });
};

// 校验tts配置 性别是否匹配
export const judgeTTSInParams = (genderType, submitParams) => {
    try {
        const newSubmitParams = _.cloneDeep(submitParams);
        let judgeStatus = true;
        newSubmitParams.content.forEach(goodsItem => {
            goodsItem.page_list.forEach(pageItem => {
                const {tts_speed, tts_tone, desc, gender} = (pageItem.tts || {});
                if (gender && gender !== genderType) {
                    pageItem.tts = {
                        tts_speed,
                        tts_tone,
                        desc
                    };
                    judgeStatus = false;
                }
            });
        });

        return {newSubmitParams, judgeStatus};
    }
    catch (e) {
        return {
            newSubmitParams: submitParams,
            judgeStatus: true
        };
    }
};

// 更新所有页面tts信息
export const updateAllPageTTSInParams = (ttsinfo, submitParams) => {
    const newSubmitParams = toJS(submitParams);
    const {tts_speed, tts_tone, tts_per: tts_timbre_id, tts_per_name: name, tts_mood} = ttsinfo;

    updateGolbalTTS({
        tts_timbre_id,
        desc: ''
    });
    newSubmitParams.content.forEach(goodsItem => {
        goodsItem.page_list.forEach(pageItem => {
            Object.assign(pageItem.tts, {
                tts_timbre_id: +tts_timbre_id,
                tts_speed: +tts_speed,
                tts_tone: +tts_tone,
                tts_mood,
                mood: tts_mood,
                name
            });
        });
    });

    return newSubmitParams;
};

export const updatePageCoverInParams = (pageId, coverUrl, submitParams) => {
    try {
        const [curGoodsId, pageIndex] = pageId.split('_');
        const newSubmitParams = toJS(submitParams);

        const curGoodsItem = (newSubmitParams.content || {}).find(ele => ele.goods_id === curGoodsId);
        const curPageItem = (curGoodsItem.page_list || []).find(ele => ele.page_index === pageIndex);

        if (curPageItem) {
            curPageItem.cover = coverUrl;
        }

        return newSubmitParams;
    }
    catch (e) {
        console.error('updatePageCoverInParams err', e);
        return submitParams;
    }
};

// draftjs升级为slate，导致原来存储的tts不可使用，所以将tts转换为slate的结构
export const formatDesc2SSML = desc => {
    if (!desc) {
        return '';
    }

    if (Array.isArray(desc)) {
        return desc;
    }

    if (typeof desc === 'string') {
        return [
            {
                type: 'blocks',
                children: [{text: desc}]
            }
        ];
    }

    const {blocks = [], entityMap = {}} = desc;

    if (!blocks || !blocks.length) {
        return '';
    }

    const newBlocks = [];
    blocks.forEach(blockItem => {
        let block = {type: 'block', children: [{text: ''}]};

        const {text, entityRanges = []} = blockItem;
        let lastIndexTemp = 0;
        entityRanges.forEach(entityItem => {
            const {offset, length, key} = entityItem;
            const {data: entityData, mutability} = entityMap[key] || {};
            const {selectText = '', tagVal, value, displayName, displayValue} = entityData;

            const preText = text.slice(lastIndexTemp, offset);
            let children = [...block.children, {text: preText}];
            block.children = children;

            switch (mutability) {
                case 'PHONEME':
                    break;
                case 'SAYAS':
                    break;
                case 'SILENCE':
                    let character = (value && displayName && displayValue) ? {displayName, displayValue, value} : null;
                    let children = [
                        ...block.children,
                        {type: 'silence', character, children: [{text: ''}]}
                    ];
                    block.children = children;
                    break;
                default:
                    break;
            }
            lastIndexTemp = offset + length;
        });
        if (lastIndexTemp < text.length) {
            let children = [...block.children, {text: text.slice(lastIndexTemp)}];
            block.children = children;
        }
        newBlocks.push(block);
    });
    return newBlocks;
};

export const formatSSML2PlainText = (blocks, type = 'plain') => {
    if (!blocks || !blocks.length) {
        return '';
    }

    if (type === 'warp') {
        return blocks.map(node => Node.string(node)).join('');
    }
    if (type === 'lineFeed') {// 有换行符
        return blocks.map(node => Node.string(node)).join('\n');
    }

    const resStr =  blocks.map(node => Node.string(node)).join('\n');

    return resStr.replace(/[\r\n]/g, '');
};

// 弃用，因为tts的存储结构已经升级为slate
export const formatSSML2FaqText = ({blocks = [], entityMap = {}}) => {
    if (!blocks.length) {
        return '';
    }

    let resArr = [];

    blocks.forEach(blockItem => {
        const {text, entityRanges = []} = blockItem;
        let lastIndexTemp = 0;

        entityRanges.forEach(entityItem => {
            const {offset, length, key} = entityItem;
            const {mutability} = entityMap[key] || {};

            const preText = text.slice(lastIndexTemp, offset);
            resArr.push(preText);

            switch (mutability) {
                case 'SILENCE':
                    resArr.push('[用户昵称]');
                    break;
                default:
                    break;
            }

            lastIndexTemp = offset + length;
        });

        if (lastIndexTemp < text.length) {
            resArr.push(text.slice(lastIndexTemp));
        }
    });

    return resArr.length ? resArr.join('') : '';
};

export const formatSSML2FaqTextBySlate = blocks => {
    if (!blocks.length) {
        return '';
    }

    let resArr = [];
    blocks.forEach(blockItem => {
        const {type, children} = blockItem || {};
        children.length && children.forEach(it => {
            const {text, character, type} = it;
            switch (type) {
                case 'silence':
                    resArr.push('[用户昵称]');
                    break;
                default:
                    resArr.push(text);
                    break;
            }
        });
    });

    return resArr.length ? resArr.join('') : '';
};
// 将draft格式处理为ssml格式，提交、预览用
export const formatSSMLInput = ({blocks = [], entityMap = {}} = {}) => {
    if (!blocks || !blocks.length) {
        return '';
    }

    let resArr = [];

    blocks.forEach(blockItem => {
        const {text, entityRanges = []} = blockItem;
        let lastIndexTemp = 0;

        entityRanges.forEach(entityItem => {
            const {offset, length, key} = entityItem;
            const {data: entityData, mutability} = entityMap[key] || {};
            const {selectText = '', tagVal, value} = entityData;

            const preText = text.slice(lastIndexTemp, offset);
            resArr.push(preText);

            switch (mutability) {
                case 'PHONEME':
                    resArr.push('<phoneme py="');
                    resArr.push(tagVal);
                    resArr.push('">');
                    resArr.push(selectText);
                    resArr.push('</phoneme>');
                    break;
                case 'SAYAS':
                    resArr.push('<say-as type="');
                    resArr.push(tagVal);
                    resArr.push('">');
                    resArr.push(selectText);
                    resArr.push('</say-as>');
                    break;
                case 'SILENCE':
                    resArr.push('<silence time="');
                    resArr.push(value);
                    resArr.push('"></silence>');
                    break;
                default:
                    break;
            }

            lastIndexTemp = offset + length;
        });

        if (lastIndexTemp < text.length) {
            resArr.push(text.slice(lastIndexTemp));
        }
    });

    return resArr.length ? `<speak>${resArr.join('')}</speak>` : '';
};
// 将slate格式处理为sssml格式，提交、预览用
export const formatSSMLInputBySlate = blocks => {
    if (!blocks || !blocks.length) {
        return '';
    }

    let resArr = [];

    blocks.forEach(blockItem => {
        const {type, children} = blockItem || {};
        children.length && children.forEach(it => {
            const {text, character, type} = it;
            const {tagVal, attr = 'type', value, text: tagText = ''} = character || {};
            switch (type) {
                case 'sayas':
                    if (attr === 'py') {
                        resArr.push('<phoneme py="');
                        resArr.push(tagVal);
                        resArr.push('">');
                        resArr.push(tagText);
                        resArr.push('</phoneme>');
                    }
                    else {
                        resArr.push('<say-as ');
                        resArr.push(attr);
                        resArr.push('="');
                        resArr.push(tagVal);
                        resArr.push('">');
                        resArr.push(tagText);
                        resArr.push('</say-as>');
                    }
                    break;
                case 'silence':
                    resArr.push('<silence time="');
                    resArr.push(value || '');
                    resArr.push('"></silence>');
                    break;
                default:
                    resArr.push(text);
                    break;
            }
        });
    });
    return resArr.length && resArr.join('').length ? `<speak>${resArr.join('')}</speak>` : '';
};

// 对于submitParams的格式化处理
export const formatSubmitParams = ({submitParams, videoPasterAuth}) => {
    const newSubmitParams = _.cloneDeep(submitParams);

    try {
        newSubmitParams.content?.forEach(goods => {
            goods?.page_list?.forEach(page => {
                const {elements} = page;
                const bgVideo = elements.find(ele => ele.type === 'bg' && ele.bgTab === 'bg_video') || {};
                let newElements = elements;
                // 视频背景替换为视频贴片
                // if (videoPasterAuth && bgVideo.url) {
                //     newElements = elements.filter(ele => ele.type !== 'bg');
                //     delete bgVideo.bgTab;
                //     newElements.unshift({
                //         ...bgVideo,
                //         type: 'video',
                //         w: '1',
                //         h: '1',
                //         x: '0',
                //         y: '0'
                //     });
                // }

                // 1、丢弃裁剪状态； 2、过滤空文本；3、搞一个新的元素id
                newElements = newElements.map(item => {
                    if (item.isClipping || item.isCropping) {
                        return {
                            ...item,
                            isClipping: false,
                            isCropping: false
                        };
                    }
                    return {
                        ...item,
                        canvasId: getUniqueElementId()
                    };
                }).filter(item => item.name);

                // 过滤多余背景元素和空背景元素
                let bgFlag = false;
                newElements = newElements.filter(item => {
                    if (item.type === 'bg') {
                        if (!item.url || bgFlag) {
                            return false;
                        }
                        bgFlag = true;
                    }
                    return true;
                });

                // 文本框升级 div -> fabric
                newElements = transElementsTextbox(newElements);

                page.elements = newElements;
            });
        });
    }
    catch (e) {
        console.log(e);
    }
    return newSubmitParams;
};

// 保存数据 cover -> 缩略图 scopeElements -> 素材生效范围 usedTemplate -> 使用过的模板 imagesInfo -> 图片素材信息（废弃）
export const formatSaveParams = async ({submitParams = {}, cover = '', customAudioMap = {}, usedTemplate = [], imagesInfo = {}, scriptType = 1}) => {
    const {script_id, content} = submitParams;
    const originContent = JSON.stringify(content.map(item => {
        return {
            ...item,
            customAudioMap,
            usedTemplate: usedTemplate.length ? usedTemplate : item?.usedTemplate
        };
    }));
    let resPageIndex = 1;
    let resContentList = [];

    const pasterImage = async (element, index, characterZindex) => {
        // 图片存在裁剪 替换bos url
        if (element.clipPath
                && element.clipPath !== 'inset(0%)'
                && element.clipPath !== 'inset(0% 0% 0% 0%)') {
            let {w, h, naturalWidth, naturalHeight} = element;
            if (!naturalWidth || !naturalHeight) {
                if (imagesInfo[element.canvasId]) {
                    naturalWidth = +imagesInfo[element.canvasId].naturalWidth;
                    naturalHeight = +imagesInfo[element.canvasId].naturalHeight;
                }
                else {
                    try {
                        const imageInfo = await getImageInfo(`${element.url.split('?')[0].replace('http:', 'https:')}?x-bce-process=image/info`);
                        naturalWidth = +imageInfo.imageWidth?.value || w * BASE_WIDTH;
                        naturalHeight = +imageInfo.imageHeight?.value || h * BASE_HEIGHT;
                        store.EditorStore.setImgInfoMap(element.canvasId, {
                            naturalWidth,
                            naturalHeight
                        });
                    }
                    catch (error) {
                        naturalWidth = w * BASE_WIDTH;
                        naturalHeight = h * BASE_HEIGHT;
                        console.log(error);
                    }
                }
            }
            const {top, right, bottom, left} = extractClipPath(element.clipPath);
            const width = 100 - left - right;
            const height = 100 - top - bottom;
            const newX = toFixedFloor((+element.x) + left * w / 100, 3);
            const newY = toFixedFloor(((+element.y) + top * h / 100), 3);
            const newW = toFixedFloor((width * w / 100), 3);
            const newH = toFixedFloor((height * h / 100), 3);
            const newUrl = `${element.url.split('?')[0]}?x-bce-process=image/crop,x_${(left * naturalWidth / 100).toFixed(0)},y_${(top * naturalHeight / 100).toFixed(0)},`
                    + `w_${(width * naturalWidth / 100).toFixed(0)},h_${(height * naturalHeight / 100).toFixed(0)}`;
            return ({
                ...element,
                x: newX || '0.079',
                y: newY || '0',
                w: newW || '0',
                h: newH || '0',
                url: newUrl,
                type: 'image',
                rank: index - (characterZindex < 0 ? 0 : characterZindex)
            });
        }
        return ({
            ...element,
            x: !isNaN(element.x) ? toFixedFloor(+element.x, 3) : '0.079',
            y: !isNaN(element.y) ? toFixedFloor(+element.y, 3) : '0',
            w: !isNaN(element.w) ? toFixedFloor(+element.w, 3) : '0',
            h: !isNaN(element.h) ? toFixedFloor(+element.h, 3) : '0',
            type: 'image',
            rank: index - (characterZindex < 0 ? 0 : characterZindex)
        });
    };

    for (const [goodsIndex, goodsItem] of content.entries()) {
        for (const page of goodsItem.page_list) {
            const {elements, page_index, tts = {}, bg_music = {}, page_type} = page;
            const audio = customAudioMap[`${goodsItem.goods_id}_${page_index}`] || {};
            const isAudioPage = audio && audio.hasOwnProperty('bos_url') && audio.bos_url.length;
            let paster = [];
            let bg = {...DEFAULT_WHITE_BACKGROUND};
            let bg_video = {};
            let character = {};
            const characterZindex = elements.findIndex(ele => ele.type === 'character');
            for (const [index, element] of elements.entries()) {
                switch (element.type) {
                    case 'bg':
                        const bgType = element.bgTab;
                        bg = bgType !== 'bg_video' ? {
                            id: element.id,
                            url: element.url,
                            name: element.name
                        } : {};
                        bg_video = bgType === 'bg_video' ? {
                            id: element.id,
                            url: element.url,
                            name: element.name,
                            poster: element.poster
                        } : {};
                        if (bg_video.url && bg.url === DEFAULT_WHITE_BACKGROUND.url) {
                            // 待确认bg对bg_video的影响 先删除默认设置的白色背景
                            bg = {};
                        }
                        break;
                    case 'image':
                        if (+element.w && +element.h) {
                            paster.push(await pasterImage(element, index, characterZindex));
                        }
                        break;
                    case 'video':
                        if (+element.w && +element.h && element.url) {
                            paster.push({
                                ...element,
                                x: !isNaN(element.x) ? toFixedFloor(+element.x, 3) : '0.079',
                                y: !isNaN(element.y) ? toFixedFloor(+element.y, 3) : '0',
                                w: !isNaN(element.w) ? toFixedFloor(+element.w, 3) : '0',
                                h: !isNaN(element.h) ? toFixedFloor(+element.h, 3) : '0',
                                type: 'video',
                                rank: index - (characterZindex < 0 ? 0 : characterZindex)
                            });
                        }
                        break;
                    case 'txt':
                        // 过滤空标签
                        if (+element.w && +element.h && element.name && element.url) {
                            paster.push({
                                ...element,
                                x: !isNaN(element.x) ? toFixedFloor(+element.x, 3) : '0.079',
                                y: !isNaN(element.y) ? toFixedFloor(+element.y, 3) : '0',
                                w: !isNaN(element.w) ? toFixedFloor(+element.w, 3) : '0',
                                h: !isNaN(element.h) ? toFixedFloor(+element.h, 3) : '0',
                                type: 'txt',
                                rank: index - (characterZindex < 0 ? 0 : characterZindex)
                            });
                        }
                        break;
                    case 'ppt':
                        if (!isAudioPage && element.posImgs && element.posImgs.length) {
                            const posImgs = await Promise.all(element.posImgs.map(pi => {
                                return pasterImage(pi, index, characterZindex);
                            }));
                            paster.push({
                                ...element,
                                x: !isNaN(element.x) ? toFixedFloor(+element.x, 3) : '0.079',
                                y: !isNaN(element.y) ? toFixedFloor(+element.y, 3) : '0',
                                w: !isNaN(element.w) ? toFixedFloor(+element.w, 3) : '0',
                                h: !isNaN(element.h) ? toFixedFloor(+element.h, 3) : '0',
                                type: 'ppt',
                                posImgs: posImgs.filter(p => typeof p.position === 'number'),
                                rank: index - (characterZindex < 0 ? 0 : characterZindex)
                            });
                        }
                        break;
                    case 'character':
                        if (!element.vis_figure_id && !element.id) {
                            character = {};
                        }
                        else {
                            character = {
                                ...element,
                                id: element.vis_figure_id || element.id,
                                x: toFixedFloor(+element.x, 3),
                                y: toFixedFloor(+element.y, 3),
                                w: toFixedFloor(+element.w || 0, 3),
                                h: toFixedFloor(+element.h || 0, 3),
                                url: getClipUrl(element),
                                rank: 0
                            };
                            if (character.h === '0.000') {
                                // 重新兜底一下
                                const {elementH} = await analyseImg(character.url, character);
                                character.h = toFixedFloor(elementH || +element.w * 1.41, 3);
                            }
                        }
                        break;
                    default:
                        break;
                }
            }

            paster = filterImageInViewport(paster);

            resContentList.push({
                page_type: page_type || PAGE_TYPE.DEFAULT,
                page: {
                    index: resPageIndex++,
                    uniq_id: page_index || '',
                    cover: ''
                },
                // 获客没有商品做下兜底
                goods: goodsItem.goods_id ? {
                    id: goodsItem.goods_id.split('-')[0],
                    name: goodsItem.goods_name,
                    open_platform: goodsItem.open_platform,
                    is_open: goodsItem.is_open,
                    index: goodsIndex + 1,
                    spu_id: goodsItem.num_id || ''
                } : {},
                bg_img: bg,
                bg_video,
                paster_img: paster,
                smart_anchor_img: character,
                tts: {
                    ...tts,
                    tts_per_new: tts.tts_timbre_id,
                    tts_speed: tts.tts_speed ? tts.tts_speed.toFixed(1) : '',
                    tts_tone: tts.tts_tone ? tts.tts_tone.toFixed(1) : '',
                    tts_volume: tts.tts_volume ? tts.tts_volume.toFixed(1) : '',
                    tts_timbre_id: tts.tts_mid ? 0 : tts.tts_timbre_id,
                    tts_per: tts.tts_mid ? 0 : (tts.tts_timbre_id ? tts.tts_timbre_id : 0),
                    tts_vc_per: tts.mood && tts.tts_vc_per ? tts.tts_vc_per : '',
                    tts_mood: tts.mood && tts.tts_vc_per ? tts.mood : ''
                },
                audio,
                bg_music,
                desc: {
                    text: formatSSMLInputBySlate(tts.desc || []),
                    xml: isAudioPage ? '0' : '1',
                    is_ai_gen: tts.is_ai_gen || 0,
                    is_asr_gen: tts.is_asr_gen || 0,
                    ai_gen_time: tts.ai_gen_time || '',
                    ai_create_time: tts.ai_create_time || '',
                    is_ai_create: tts.is_ai_create || 0,
                    gen_type: tts.gen_type || '',
                    gen_task_id: tts.gen_task_id || '',
                    ai_create_ids: tts.ai_create_ids || '',
                    ai_gen_ids: tts.ai_gen_ids || ''

                },
                template: usedTemplate
            });
        }
    }

    if (!script_id) {
        return null;
    }

    return {
        script_id,
        script_type: scriptType,
        cover: cover || '',
        content: resContentList.length ? JSON.stringify(resContentList) : '',
        origin_content: originContent,
        content_md5: resContentList.length ? md5(JSON.stringify(resContentList)) : ''
    };
};

// 过滤完全超出视口的图片
export const filterImageInViewport = (paster) => {
    paster = paster.filter(item => { // 过滤完全超出视口的图片
        if (typeof item.inViewport === 'boolean' && !item.inViewport) { // 在编辑器中打的标记
            return false;
        }
        if (!item.r && (item.x + item.w < 0 || item.y + item.h < 0 || item.x > 1 || item.y > 1)) {
            return false;
        }
        return true;
    });
    return paster;
};

// 获取page_index与下标index的一一对应
export const getPageIndexs = (submitParams = {}) => {
    const {content = []} = submitParams;

    let resPageIndex = 1;
    let resContentList = [];

    content.forEach((goodsItem, goodsIndex) => {
        let {goods_id = '', page_list = []} = goodsItem;

        page_list.forEach(page => {
            const {page_index} = page;
            resContentList.push({
                index: resPageIndex,
                pageIndex: page_index,
                goodsId: goods_id
            });
            resPageIndex++;
        });
    });
    return resContentList;
};

// 处理剧本回填数据
export const parseDefaultInfo = info => {
    const {script_id, script_title, cover, watermark, origin_content, customer_acquisition} = info;
    let resContent = [];
    let pageId = '';

    try {
        if (origin_content) {
            resContent = JSON.parse(origin_content);

            if (resContent.length) {
                // 处理存量剧本ssml
                resContent.forEach(goodsItem => {
                    const pageList = goodsItem.page_list || [];

                    pageList.forEach(pageItem => {
                        const {tts} = pageItem;

                        // 避免tts为null
                        if (tts) {
                            tts.desc = formatDesc2SSML(tts.desc, 1000);
                        }
                    });
                });

                const goodsItem = resContent[0];
                let activeGoodsId = '';
                let activePageIndex = '';

                activeGoodsId = goodsItem.goods_id;

                if (goodsItem.page_list && goodsItem.page_list.length) {
                    activePageIndex = goodsItem.page_list[0].page_index;

                    updateGolbalTTS({
                        ...goodsItem.page_list[0].tts,
                        tts_tone: '',
                        tts_speed: '',
                        desc: ''
                    });
                }

                if (activeGoodsId && activePageIndex !== '') {
                    pageId = `${activeGoodsId}_${activePageIndex}`;
                }
            }
        }
    }
    catch (e) {
        // 数据异常 返回上一页
        return null;
    }

    return {
        script_id,
        script_title,
        watermark,
        cover,
        content: resContent,
        pageId,
        customer_acquisition: customer_acquisition || {} // 获客数据
    };
};

export const getPageInfoFromParams = (pageId, submitParams) => {
    try {
        const [curGoodsId, pageIndex] = pageId.split('_');
        const newSubmitParams = toJS(submitParams);
        const curGoodsItem = newSubmitParams.content.find(ele => ele.goods_id === curGoodsId);
        const curPageItem = curGoodsItem.page_list.find(ele => ele.page_index === pageIndex);
        return curPageItem || {};
    }
    catch (e) {
        return {};
    }
};

// 从content中获取商品goods_id
export const formatGoodsList = originContent => {
    try {
        const goodsList = JSON.parse(originContent);

        return goodsList.map((item, index) => {
            return {
                goods_id: item.goods_id.split('-')[0],
                index_id: index + 1
            };
        });
    }
    catch (e) {
        console.error('format goods list', e);
    }
};

// 根据content校验是否可开播
export const checkScriptCanLive = content => {
    try {
        if (!content) {
            return '剧本至少需要一页内容';
        }

        const pageList = JSON.parse(content);

        // 至少有一页
        if (!pageList || !pageList.length) {
            return '剧本至少需要一页内容';
        }

        // 至少传了一个音频
        const hasValidAudio = pageList.some(ele => {
            return !!ele.audio && !!ele.audio.bos_url;
        });

        // 至少有一条描述文案
        const hasValidDesc = pageList.some(ele => {
            return !!ele.desc && !!ele.desc.text;
        });

        if (!hasValidDesc && !hasValidAudio) {
            return '剧本至少需要一条音频文件或描述文案';
        }

        // 必须有数字人
        const noCharacter = pageList.some(ele => {
            return !ele.smart_anchor_img || !ele.smart_anchor_img.id;
        });
        if (noCharacter) {
            return '剧本必须添加一个数字人';
        }

        // 非录音场景 必须全部选择音色
        const noTimbreIndex = pageList.findIndex(ele => {
            const {audio} = ele;
            const hasAudio = (audio && audio.hasOwnProperty('bos_url') && audio.bos_url.length);

            return !hasAudio && !ele.tts.tts_per && !ele.tts.tts_vc_per && !ele.tts.tts_timbre_id && !ele.tts.tts_mid;
        });
        if (noTimbreIndex > -1) {
            return `所有页面必须选择音色，请检查第${noTimbreIndex + 1}页`;
        }

        // 非录音场景 必须全部选择风格
        const noMoodIndex = pageList.findIndex(ele => {
            const {audio} = ele;
            const hasAudio = (audio && audio.hasOwnProperty('bos_url') && audio.bos_url.length);

            return !hasAudio && !ele.tts.mood && !ele.tts.tts_mood && !ele.tts.tts_mid;
        });
        if (noMoodIndex > -1) {
            return `所有页面必须选择声音风格，请检查第${noMoodIndex + 1}页`;
        }

        return '';
    }
    catch (e) {
        console.error('checkScriptCanLive err', e);
        return '此剧本暂时无法开播，请完善剧本内容';
    }
};

// 贴片、人像负值处理
// 背景图裁切尺寸 16:9处理 宽378px 高672px
// BOS图片裁剪规则 https://cloud.baidu.com/doc/BOS/s/tldh5worb
export const getClipUrl = item => {
    const WIDTH = 378;
    const HEIGHT = 672;
    const {w, h, x, y, url} = item;
    let offsetX;
    let offsetY;
    let clipWidth;
    let clipHeight;
    let clipParams = '';

    // 图片左侧超过画布
    if (x < 0) {
        offsetX = Math.round(Math.abs(x) * WIDTH);
        clipParams += `@c_1,x_${offsetX}`;
    }

    // 图片右侧超过画布
    if ((x + w) > 1) {
        offsetX = 0;
        clipWidth = Math.round((1 - x) * WIDTH);

        clipParams += `@c_1,x_${offsetX},width_${clipWidth}`;
    }

    // 图片顶部超过画布
    if (y < 0) {
        offsetY = Math.round(Math.abs(y) * HEIGHT);

        clipParams += `,y_${offsetY}`;
    }

    // 图片底部超过画布
    if ((y + h) > 1) {
        offsetY = 0;
        clipHeight = Math.round((1 - y) * HEIGHT);

        clipParams += `,y_${offsetY},height_${clipHeight}`;
    }
    // console.log(`${url}${clipParams}`);
    return `${url}${clipParams}`;
};

export const getCoverElements = (content) => {
    try {
        const parsedContent = Array.isArray(content) ? content : JSON.parse(content);
        const pageList = (parsedContent[0] || {}).page_list || [];
        const elements = (pageList[0] || {}).elements || [];

        return elements;
    }
    catch (e) {
        return [];
    }
};

// 审核相关方法
export const getRiskMap =  (result = {}) => {
    let riskMap = new Map();

    Object.entries(result).forEach(([key, value]) => {
        const {reason = [], sensitive_words = [], words = [], ppt_result = {}} = value || {};
        let ids = key.split('|') || [];

        if (ids[0] && +ids[1] > -1) {
            let element = {
                reason: reason || [],
                words: Array.from(new Set([...(sensitive_words || []), ...(words || [])])),
                canvasId: ids[2] || '',
                type: ids[2] ? RISK_TYPE_MAP[ids[0]]
                    : (RISK_TYPE_MAP[ids[0]] === 'image'
                        ? 'bg'
                        : (RISK_TYPE_MAP[ids[0]] === 'txt' ? 'tts' : RISK_TYPE_MAP[ids[0]])),
                status: (words && words.length > 0) ? 'error' : 'warning'
            };
            if (ids[0] === 'p') {
                element.pptResult = ppt_result;
            }
            if (riskMap.has(ids[1])) {
                riskMap.get(ids[1]).elements.push({...element});
            }
            else {
                riskMap.set(ids[1], {elements: [element]});
            }
        }
    });

    return riskMap;
};

export const getRiskList = (result = {}) => {
    let riskList = [];

    Object.entries(result).forEach(([key, value]) => {
        const {reason, sensitive_words = [], words = []} = value || {};
        let ids = key.split('|') || [];

        if (ids[0] && +ids[1] > -1) {
            const element = {
                pageId: ids[1] || '',
                canvasId: ids[2] || '',
                type: ids[2] ? RISK_TYPE_MAP[ids[0]]
                    : (RISK_TYPE_MAP[ids[0]] === 'image'
                        ? 'bg'
                        : (RISK_TYPE_MAP[ids[0]] === 'txt' ? 'tts' : RISK_TYPE_MAP[ids[0]])),
                reason: reason || [],
                words: Array.from(new Set([...(sensitive_words || []), ...(words || [])])),
                status: (words && words.length > 0) ? 'error' : 'warning'
            };
            riskList.push(element);
        }
    });

    return riskList;
};

// 获取block中字符长度
export const getBlocksTextLength = blocks => {
    if (!blocks) {
        return 0;
    }
    const rec = blocks.map(node => Node.string(node)).join('\n');
    return (rec.replace(/[\r\n]/g, '') || '').length;
};

export const deleteKeysWithValueOne = (obj, target) => {
    return Object.entries(obj).reduce((accumulator, [key, value]) => {
      if (value.page_type !== target) {
        accumulator[key] = value;
      }
      return accumulator;
    }, {});
};
